import axios from "@/lib/axios";

export const getAllHaafPayments = async () => {
  const { data } = await axios.get("/haaf-payments");
  return data.data;
};

export const getHaafPayment = async (id) => {
  const { data } = await axios.get(`/haaf-payments/${id}`);
  return data.data;
};

export const createHaafPayment = async (paymentData) => {
  const { data } = await axios.post("/haaf-payments", paymentData);
  return data.data;
};

export const updateHaafPayment = async ({ id, ...paymentData }) => {
  const { data } = await axios.put(`/haaf-payments/${id}`, paymentData);
  return data.data;
};

export const deleteHaafPayment = async (id) => {
  const { data } = await axios.delete(`/haaf-payments/${id}`);
  return data.data;
};

export const verifyHaafPayment = async (id) => {
  const { data } = await axios.put(`/haaf-payments/${id}/verify`);
  return data.data;
};

export const unverifyHaafPayment = async (id) => {
  const { data } = await axios.put(`/haaf-payments/${id}/unverify`);
  return data.data;
};

export const getChapterHaafPayments = async () => {
  const { data } = await axios.get("/haaf-payments/chapter");
  return data.data;
};

export const getHaafPaymentsByBatch = async (batch) => {
  const { data } = await axios.get(`/haaf-payments/batch/${batch}`);
  return data.data;
};

export const getHaafPaymentStats = async () => {
  const { data } = await axios.get("/haaf-payments/stats");
  return data.data;
};

export const getHaafPaymentBatchStats = async () => {
  const { data } = await axios.get("/haaf-payments/batch-stats");
  return data.data;
};

export const getHaafPaymentChapterStats = async () => {
  const { data } = await axios.get("/haaf-payments/chapter-stats");
  return data.data;
};
